import { render, staticRenderFns } from "./ElemRoot.vue?vue&type=template&id=1574f9a6&scoped=true"
import script from "./ElemRoot.vue?vue&type=script&lang=js"
export * from "./ElemRoot.vue?vue&type=script&lang=js"
import style0 from "./ElemRoot.vue?vue&type=style&index=0&id=1574f9a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1574f9a6",
  null
  
)

export default component.exports